import { Button, Col, Image, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import UseAdmission from '../hooks/useAdmission';
import AdmissionSummary from './AdmissionSummary';

const PatientEntry = ({
  reservation,
  patientToAdmission,
  setPatientToAdmission,
  currentStep,
  setStartAdmission,
  providerCode,
  countryCode,
  laboratoryModule
}) => {
  const { t } = useTranslation();

  const useAdmission = UseAdmission(
    reservation,
    patientToAdmission,
    setPatientToAdmission,
    currentStep,
    setStartAdmission,
    t,
    true,
  );

  return (
    <Row
      gutter={32}
      justify="center"
      className="admission-settings__patient-entry mt-50 mb-50"
    >
      <AdmissionSummary
        patientToAdmission={patientToAdmission}
        setPatientToAdmission={setPatientToAdmission}
        currentStep={currentStep}
        providerCode={providerCode}
        countryCode={countryCode}
        laboratoryModule={laboratoryModule}
      />

      <Col lg={8} xs={22}>
        {
          patientToAdmission &&
          <Row justify='end' className='mt-20'>
            <Col span={24} className='text-right mb-20'>
              <Image
                width={200}
                src={patientToAdmission.pictureIdCard?.photo}
              />
            </Col>
            <Col xl={10} lg={20} xs={24}>
              <Button
                loading={useAdmission.loading}
                onClick={useAdmission.validateAndRefactorData}
                className="cmt-button primary"
                type="primary"
                size="large"
                block
              >
                Finalizar {t('admissionPage.patientEntry.patient')}
              </Button>
            </Col>
          </Row>
        }
      </Col>

    </Row>
  );
};

export default PatientEntry;